export const learnMoreLink =
    'https://support.approvalmax.com/portal/en/kb/articles/what-is-the-fraud-detection-changes-after-approval-setting-netsuite';

export const checkBoxQaPrefix = 'NetSuiteFraudDetectionChangesAfterSection';
